<tt-input ttLabel="tt_wizard_name" [(ttModel)]="params!.bsp_wizard_name" ttRequired></tt-input>
<tt-grid *ngIf="!!grid" [(ttOptions)]="grid" class="flex-1"></tt-grid>
